export default __webpack_public_path__ + "static/media/background.e2b582c2.jpg";